<template>
  <div class="page">
    <div id="page-header" class="page-header">
      <h2 class="page-header__title">お支払い方法</h2>
    </div>
    <div id="page-content" class="page-content">
      <Accordion :content="inputSummary"></Accordion>
      <article>
        <div>
          <table class="table table-bordered page-content__price-table">
            <tbody>
              <tr>
                <td class="page-content__price-table-tr-title">受講コース</td>
                <td class="page-content__price-table-tr-course">
                  {{ this.course.name }}
                </td>
              </tr>
              <tr>
                <td class="page-content__price-table-tr-title">お支払い金額</td>
                <td class="page-content__price-table-tr-price">
                  {{ this.course.price }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <section class="page-content__course-radio-wrapper">
          <label class="big-radio">
            <input
              type="radio"
              name="course-radio"
              value="A"
              v-model="payBy"
              @change="selectCreditCard()"
              class="big-radio--input"
            />
            <span class="big-radio--dummy-input"></span>
            <span class="big-radio--label-text">クレジットカード決済</span></label
          >
          <!-- <label class="big-radio">
            <input
              type="radio"
              name="course-radio"
              value="E"
              v-model="payBy"
              @change="selectConvinience()"
              class="big-radio--input"
            />
            <span class="big-radio--dummy-input"></span>
            <span class="big-radio--label-text">コンビニ決済</span></label
          > -->
          <label class="big-radio">
            <input
              type="radio"
              name="course-radio"
              value="F"
              v-model="payBy"
              @change="selectPayPay()"
              class="big-radio--input"
            />
            <span class="big-radio--dummy-input"></span>
            <span class="big-radio--label-text">PayPay決済</span></label
          >
          <label class="big-radio">
            <input
              type="radio"
              name="course-radio"
              value="B"
              v-model="payBy"
              @change="selectBankTransfer()"
              class="big-radio--input"
            />
            <span class="big-radio--dummy-input"></span>
            <span class="big-radio--label-text">事前振り込み</span></label
          >
        </section>
        <section class="page-content__course-radio-wrapper">
          <aside v-show="creditCardChecked">
            <div class="page-content__banktransfer-wrapper">
              GMOイプシロン社のクレジットカード決済ページに移動します。<br />
              ご入金確認後にメールにて受講サイトのURLとログイン用のIDとパスワードをお送り致します。
              <ul class="page-content__payment-image-list">
                <li class="page-content__payment-image-item">
                  <img src="../../../../images/payment/logo_ae.gif" alt="AmericanExpress" />
                </li>
                <li class="page-content__payment-image-item">
                  <img src="../../../../images/payment/logo_diners.gif" alt="Dinvers" />
                </li>
                <li class="page-content__payment-image-item">
                  <img src="../../../../images/payment/logo_jcb.gif" alt="JCB" />
                </li>
                <li class="page-content__payment-image-item">
                  <img src="../../../../images/payment/logo_master.gif" alt="Master" />
                </li>
                <li class="page-content__payment-image-item">
                  <img src="../../../../images/payment/logo_visa.gif" alt="VISA" />
                </li>
              </ul>
            </div>
          </aside>
          <aside v-show="convinienceChecked">
            <div class="page-content__banktransfer-wrapper">
              GMOイプシロン社のコンビニ決済ページに移動します。<br />
              ご入金確認後にメールにて受講サイトのURLとログイン用のIDとパスワードをお送り致します。
              <ul class="page-content__payment-image-list">
                <li class="page-content__payment-image-item">
                  <img src="../../../../images/payment/logo_711.gif" alt="SevenEleven" />
                </li>
                <li class="page-content__payment-image-item">
                  <img src="../../../../images/payment/logo_familymart.gif" alt="FamilyMart" />
                </li>
                <li class="page-content__payment-image-item">
                  <img src="../../../../images/payment/logo_lawson.gif" alt="Lawson" />
                </li>
                <li class="page-content__payment-image-item">
                  <img src="../../../../images/payment/logo_mini.gif" alt="MiniStop" />
                </li>
                <li class="page-content__payment-image-item">
                  <img src="../../../../images/payment/logo_seico.gif" alt="SeicoMart" />
                </li>
              </ul>
            </div>
          </aside>
          <aside v-show="payPayChecked">
            <div class="page-content__banktransfer-wrapper">
              GMOイプシロン社のPayPay決済ページに移動します。<br />
              ご入金確認後にメールにて受講サイトのURLとログイン用のIDとパスワードをお送り致します。
              <ul class="page-content__payment-image-list">
                <li class="page-content__payment-image-item">
                  <img src="../../../../images/payment/logo_paypay.gif" alt="PayPay" />
                </li>
              </ul>
            </div>
          </aside>
          <aside v-show="bankTransferChecked">
            <div class="page-content__banktransfer-wrapper">
              事前振り込みをご希望の方は、お申込み確認後、お振込み先口座をメールにて送付いたしますので、ご確認の程宜しくお願い致します。<br />
              <span style="color: red">※なお、振り込み手数料はお客様でご負担ください。</span><br />
              ご入金確認後にメールにて受講サイトのURLとログイン用のIDとパスワードをお送り致します。
            </div>
          </aside>
        </section>
      </article>
    </div>
    <div id="page-footer" class="page-footer">
      <div class="page-footer__next-button-wrapper">
        <div class="page-footer__next-button-inner">
          <router-link to="/medical-check" custom v-slot="{ navigate }">
            <button id="nextButton" class="btn btn-secondary rounded-pill" @click="navigate">
              前ページに戻る
            </button>
          </router-link>
        </div>
        <div class="page-footer__next-button-inner">
          <button
            id="nextButton"
            class="btn btn-danger rounded-pill"
            :disabled="!isSubmit"
            @click="register"
          >
            お支払方法を選択し、申込を完了する
          </button>
        </div>
      </div>
    </div>
    <!-- モーダルダイアログ -->
    <div id="loading" v-show="isShowDialog" class="page-content__overlay">
      <vue-loading
        v-show="isShowLoading"
        type="spiningDubbles"
        color="#fff"
        :size="{ width: '100px', height: '100px' }"
      ></vue-loading>
      <div id="content" v-show="isShowResult" class="page-content__overlay-contents">
        <article>
          <section>
            <div class="page-content__article-section-body--dialog-message">
              <p class="page-content__dialog-message--error">{{ this.resultMessage }}</p>
              <p>
                BSAC担当者まで上記メッセージまたはエラーコードをご連絡ください。<br />
                TEL: 03-5297-5656 / e-mail: training@bsac.jp
              </p>
            </div>
          </section>
        </article>
        <div class="page-footer__next-button-wrapper">
          <div class="page-footer__next-button-inner">
            <router-link to="/" custom v-slot="{ navigate }">
              <button id="nextButton" class="btn btn-danger rounded-pill" @click="navigate">
                トップ画面に戻る
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- モーダルダイアログ -->
  </div>
</template>

<script>
import Accordion from 'vues/common/components/parts/Accordion';
import { VueLoading } from 'vue-loading-template';

export default {
  /**
   * 次の画面に遷移する前に実行する
   */
  // async beforeRouteLeave(to, from, next) {
  //   this.isShowDialog = true;
  //   this.isShowLoading = true;

  //   if (
  //     this.$store.getters['elearningApplication/registerResponse'] !== null &&
  //     this.$store.getters['elearningApplication/registerResponse'].message !== null
  //   ) {
  //     this.$router.push('/');
  //   }

  //   // 登録する
  //   const res = await this.$store.dispatch('elearningApplication/register');

  //   this.isShowLoading = false;
  //   this.isShowResult = true;
  //   this.registerResult = res;

  //   // エラーが発生した場合はページを遷移しない
  //   next(res.success && res.status === 201 && res.message === null);
  // },
  components: {
    Accordion,
    VueLoading,
  },
  computed: {
    /**
     *
     */
    course: function () {
      let course = { name: '', price: '' };
      const selectedCourse = this.$store.getters['elearningApplication/course'];

      if (!selectedCourse) return course;

      if (selectedCourse.name) {
        course.name = selectedCourse.name;
      }
      if (selectedCourse.price) {
        course.price = '¥' + selectedCourse.priceWithTax.toLocaleString() + '（税込）';
      }
      return course;
    },
    /**
     * 入力概要
     */
    inputSummary: function () {
      return this.$store.getters['elearningApplication/inputSummary'];
    },
    /**
     * 次の画面に遷移可能かを判定する
     */
    isSubmit: {
      cache: false,
      get() {
        let result = this.creditCardChecked;
        result = result || this.convinienceChecked;
        result = result || this.payPayChecked;
        result = result || this.bankTransferChecked;
        return result;
      },
    },
    /**
     * 結果メッセージ
     */
    resultMessage: function () {
      let message = null;
      if (this.registerResult === null) return message;

      message = this.registerResult.message + '\n\n';

      return message;
    },
  },
  data() {
    return {
      creditCardChecked: false,
      convinienceChecked: false,
      payPayChecked: false,
      bankTransferChecked: false,
      isShowDialog: false,
      isShowLoading: false,
      isShowResult: false,
      payBy: null,
      registerResult: null,
    };
  },
  methods: {
    /**
     * 申込内容を登録する
     * 動的に遷移先を切り分けるためbeforeRouteLeaveメソッドは使わない
     */
    register: async function () {
      this.isShowDialog = true;
      this.isShowLoading = true;

      // エラーメッセージがセット済みの場合はトップ画面に遷移する
      if (
        this.$store.getters['elearningApplication/registerResponse'] !== null &&
        this.$store.getters['elearningApplication/registerResponse'].message !== null
      ) {
        this.$router.push('/');
      }

      try {
        // 登録する
        const res = await this.$store.dispatch('elearningApplication/register');

        if (res.success && res.status === 201 && res.message === null) {
          // 完了画面に遷移する
          this.$router.push('/completed');
        }
        this.isShowResult = true;
        this.registerResult = res;
      } finally {
        this.isShowLoading = false;
      }
    },
    /**
     * 入力値をストアに保存する
     */
    saveDataInStore: function () {
      this.$store.commit('elearningApplication/setPayBy', this.payBy);
    },
    /**
     * クレジットカード決済を選択する
     */
    selectCreditCard: function () {
      this.creditCardChecked = true;
      this.convinienceChecked = false;
      this.payPayChecked = false;
      this.bankTransferChecked = false;
      this.saveDataInStore();
    },
    /**
     * コンビニ決済を選択する
     */
    selectConvinience: function () {
      this.creditCardChecked = false;
      this.convinienceChecked = true;
      this.payPayChecked = false;
      this.bankTransferChecked = false;
      this.saveDataInStore();
    },
    /**
     * PayPay決済を選択する
     */
    selectPayPay: function () {
      this.creditCardChecked = false;
      this.convinienceChecked = false;
      this.payPayChecked = true;
      this.bankTransferChecked = false;
      this.saveDataInStore();
    },
    /**
     * 事前振込みを選択する
     */
    selectBankTransfer: function () {
      this.creditCardChecked = false;
      this.convinienceChecked = false;
      this.payPayChecked = false;
      this.bankTransferChecked = true;
      this.saveDataInStore();
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/input-form.scss';
@import 'stylesheets/page.scss';
@import 'stylesheets/big-radio.scss';

.page-content__price-table {
  width: 80%;
  min-width: 300px;
  max-width: 500px;
  margin: 2rem auto 2rem auto;
  padding: 1rem 1rem 1rem 1rem;
  font-size: 0.8rem;
  text-align: center;
  vertical-align: middle;

  &-tr-title {
    width: 125px;
  }

  // &-tr-course {
  // }

  &-tr-price {
    font-size: 1.8rem;
    color: #ff0033;
  }
}

.page-content__creditcard-input-forms {
  width: 80%;
  min-width: 300px;
  max-width: 500px;
  height: auto;
  margin: 2rem auto 2rem auto;
  padding: 1rem 1rem 1rem 1rem;

  border-style: solid;
  border-width: 0.5px;
  border-radius: 1rem;
  box-shadow: 0 10px 25px 0 rgba(0, 0, 0, 0.5);
}

.page-content__banktransfer-wrapper {
  width: 80%;
  min-width: 300px;
  max-width: 500px;
  height: auto;
  margin: 2rem auto 2rem auto;
  padding: 1rem 1rem 1rem 1rem;
}

.page-content__dialog-message--error {
  white-space: pre-wrap;
  color: red;
  font-weight: bold;
}

.page-content__payment-image-list {
  margin: 2rem auto auto auto;
  display: flex;
  justify-content: center;
}
.page-content__payment-image-item {
  list-style: none;
}
</style>
